import React, { memo, useCallback } from 'react';
import { Button } from '../../Button/Button';
import { Grid, Segment } from 'semantic-ui-react';
import { formatMoney } from '../../../utils/formatters';
import { mapOpportunityTypeToText } from './utils';
import { OpportunityIcon } from '../../Icon';
import { OpportunityModal } from './OpportunityModal';


var Opportunity = function (_a) {
    var opportunity = _a.opportunity, onOpportunityClick = _a.onOpportunityClick;
    var handleOpportunityClick = useCallback(function () {
        onOpportunityClick === null || onOpportunityClick === void 0 ? void 0 : onOpportunityClick(opportunity.id);
    }, [onOpportunityClick, opportunity]);
    return (React.createElement(Segment, { className: 'Opportunity pluggy' },
        React.createElement(Grid, { columns: 6 },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { className: 'product-brand', width: 5 },
                    React.createElement("div", { className: 'product-logo' },
                        React.createElement(OpportunityIcon, null)),
                    React.createElement("div", { className: 'product-name' },
                        React.createElement("p", { className: 'column-header' }, "Tipo de oportunidade"),
                        React.createElement("p", { className: 'ellipsis' }, mapOpportunityTypeToText(opportunity.type)))),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Limite dispon\u00EDvel"),
                    React.createElement("p", { className: 'ellipsis' }, (opportunity === null || opportunity === void 0 ? void 0 : opportunity.availableLimit) ? formatMoney(opportunity.availableLimit, opportunity.currencyCode)
                        : '-')),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Taxa de juro"),
                    React.createElement("p", null, opportunity.interestRate || '-')),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Nome"),
                    React.createElement("p", { className: 'ellipsis' }, opportunity.name)),
                React.createElement(OpportunityModal, { opportunity: opportunity, trigger: React.createElement(Grid.Column, { textAlign: 'right', verticalAlign: 'middle', onClick: handleOpportunityClick },
                        React.createElement(Button, { link: true }, "Veja detalhes")) })))));
};
export default memo(Opportunity);
